import { useEffect, useRef } from "react";
import { createRoot } from "react-dom/client";

import "./admin/style.scss";
import "./admin/licence";
import { htmlToElement } from "../../wp-utils/v1";
// import { Chart } from "chart.js";
(function ($) {
  $(document).ready(function () {
    //Import Data
    $(".h5vp_import_data").on("click", function (e) {
      e.preventDefault();
      $.ajax({
        url: h5vpAdmin?.ajaxUrl,
        data: {
          action: "h5vp_import_data_ajax",
        },
        success: (data) => {
          const result = JSON.parse(data);
          if (result?.success === true) {
            location.href = location.href + "?h5ap-import=success";
          }
        },
      });
    });

    // Codestar metabox controller
    $(".h5vp_player_type .csf-fieldset .csf--button-group .csf--button").on("click", function () {
      setTimeout(() => {
        $(".h5vp_player_type_controls").addClass("h5vp_player_controls_click_trigger newclassbro");
        $(".h5vp_player_controls_click_trigger").removeClass("h5vp_player_type_controls");
        const playerType = $(this).parent(".csf--button-group").find(".csf--active input").val();
        $('.h5vp_player_controls_click_trigger .csf-fieldset .csf--button-group .csf--button input[value="' + playerType + '"]')
          .parent()
          .trigger("click");

        $(".h5vp_player_controls_click_trigger").removeClass("h5vp_player_controls_click_trigger");
      }, 100);
      setTimeout(() => {
        $(".newclassbro").addClass("h5vp_player_type_controls");
      }, 1000);
    });

    $(".h5vp_player_type_controls .csf-fieldset .csf--button-group .csf--button").on("click", function () {
      setTimeout(() => {
        $(".h5vp_player_type").addClass("h5vp_player_click_trigger");
        $(".h5vp_player_controls_click_trigger").removeClass("h5vp_player_type");
        const playerType = $(this).parent(".csf--button-group").find(".csf--active input").val();
        $('.h5vp_player_click_trigger .csf-fieldset .csf--button-group .csf--button input[value="' + playerType + '"]')
          .parent()
          .trigger("click");
        $(".h5vp_player_click_trigger").removeClass("h5vp_player_click_trigger");
      }, 100);
      setTimeout(() => {
        $(".h5vp_player_click_trigger").addClass("h5vp_player_type");
      }, 1000);
    });

    //duplicate player
    $(".h5vp_duplicate_player").on("click", function (event) {
      event.preventDefault();
      $.post(
        h5vpAdmin.ajaxUrl,
        {
          action: "h5vp_dulicate_player",
          postid: $(this).data("postid"),
          security: $(this).attr("security"),
        },
        function (data) {
          if (data) {
            let location = window.location.href;
            if (location.split("?").length > 1) {
              location = location + "&duplicate=success";
            } else {
              location = location + "?duplicate=success";
            }
            window.location.href = location;
          }
        }
      );
    });

    let url = window.location.href;
    let newUrl = url.search("duplicate=success");
    if (newUrl != "-1") {
      window.history.pushState({ urlPath: "edit.php?post_type=videoplayer" }, "", "edit.php?post_type=videoplayer");
    }

    //shortcode copier
    $(document).on("click", ".h5vp_front_shortcode input", function (e) {
      e.preventDefault();

      let shortcode = $(this).parent().find("input")[0];
      shortcode.select();
      shortcode.setSelectionRange(0, 30);
      document.execCommand("copy");
      $(this).parent().find(".htooltip").text("Copied Successfully!");
    });

    $(document).on("mouseout", ".h5vp_front_shortcode input", function () {
      $(this).parent().find(".htooltip").text("Copy To Clipboard");
    });

    // show/hide password in protected field
    $(".h5vp_show_password").on("click", function () {
      let type = $(this).parent().find("input").attr("type");
      if (type == "password") {
        $(this).parent().find("input").attr("type", "text");
      } else {
        $(this).parent().find("input").attr("type", "password");
      }
    });

    //redirect user page when click on user tr
    $(".h5vp-analytics table tr").on("click", function () {
      if (this.getAttribute("to")) {
        location.href = location.href.match(/(.+)&page=analytics/g)[0] + `&${this.getAttribute("to")}`;
      }
    });

    //initialize chart
    const chart = document.getElementById("myChart");
    // const labels = ["January", "February", "March", "April", "May", "June"];
    const labels = chart && chart.getAttribute("data-labels") && JSON.parse(chart.getAttribute("data-labels"));
    const value = chart && chart.getAttribute("data-data") && JSON.parse(chart.getAttribute("data-data"));
    const data = {
      labels: labels,
      datasets: [
        {
          label: "Views",
          backgroundColor: "rgb(255, 99, 132)",
          borderColor: "rgb(255, 99, 132)",
          color: "rgb(255, 99, 132)",
          data: value,
          tension: 0.4,
        },
      ],
    };
    const config = {
      type: "line",
      data: data,
      options: {},
      plugins: [
        {
          id: chart && chart.getAttribute("id"),
          beforeDraw: (chart) => {
            const ctx = chart.canvas.getContext("2d");
            ctx.save();
            ctx.globalCompositeOperation = "destination-over";
            ctx.fillStyle = "#fff";
            // ctx.
            ctx.fillRect(0, 0, chart.width, chart.height);
            ctx.restore();
          },
        },
      ],
    };
    if (chart) {
      var myChart = new Chart(chart, config);
      chart.setAttribute("data-labels", "");
      chart.setAttribute("data-data", "");
      myChart.fillStyle = "#fff";
      console.log(myChart);
    }
    //ready end

    //convert srt file
    const convertButton = document.getElementById("h5vp_srt_convert_button");

    if (convertButton) {
      convertButton.onclick = async (e) => {
        e.preventDefault();
        const srtFile = document.getElementById("h5vp_srt_file").value;
        const result = await fetch(srtFile);
        const blob = await result.blob();
        if (blob) {
          var reader = new FileReader();
          reader.readAsText(blob, "UTF-8");
          reader.onload = function (evt) {
            const content = srt2webvtt(evt.target.result);
            // console.log(content);
            download(
              srtFile
                .substring(srtFile.lastIndexOf("/") + 1)
                .split(".")
                .slice(0, -1)
                .join(".") + ".vtt",
              content
            );
            document.getElementById("h5vp_srt_file").value = "";
          };
          reader.onerror = function (evt) {};
        }
      };
    }

    function srt2webvtt(data) {
      // remove dos newlines
      var srt = data.replace(/\r+/g, "");
      // trim white space start and end
      srt = srt.replace(/^\s+|\s+$/g, "");

      // get cues
      var cuelist = srt.split("\n\n");
      var result = "";

      if (cuelist.length > 0) {
        result += "WEBVTT\n\n";
        for (var i = 0; i < cuelist.length; i = i + 1) {
          result += convertSrtCue(cuelist[i]);
        }
      }

      return result;
    }

    function convertSrtCue(caption) {
      // remove all html tags for security reasons
      //srt = srt.replace(/<[a-zA-Z\/][^>]*>/g, '');

      var cue = "";
      var s = caption.split(/\n/);

      // concatenate muilt-line string separated in array into one
      while (s.length > 3) {
        for (var i = 3; i < s.length; i++) {
          s[2] += "\n" + s[i];
        }
        s.splice(3, s.length - 3);
      }

      var line = 0;

      // detect identifier
      if (!s[0].match(/\d+:\d+:\d+/) && s[1].match(/\d+:\d+:\d+/)) {
        cue += s[0].match(/\w+/) + "\n";
        line += 1;
      }
      // return s[line];

      // get time strings
      if (s[line].match(/\d+:\d+:\d+/)) {
        // convert time string
        var m = s[line].match(/(\d+):(\d+):(\d+)(?:,?\.?(\d+))?\s*-?-?>?,?\s*(\d+):(\d+):(\d+)(?:,?\.?(\d+))?/);
        // var m = s[line].match(/(\d+):(\d+):(\d+)(?:,?.?(\d+))?\s*-?-?>?,?\s*(\d+):(\d+):(\d+)(?:,?.?(\d+))?/);
        if (m) {
          cue += m[1] + ":" + m[2] + ":" + m[3] + "." + m[4] + " --> " + m[5] + ":" + m[6] + ":" + m[7] + "." + m[8] + "\n";
          line += 1;
        } else {
          // Unrecognized timestring
          return "";
        }
      } else {
        // file format error or comment lines
        return "";
      }

      // get cue text
      if (s[line]) {
        cue += s[line];
        if (s[line + 1]) {
          cue += "\n";
          cue += s[line + 1] + "\n\n";
        } else {
          cue += "\n\n";
        }
      }
      return cue;
    }

    function download(filename, text) {
      var element = document.createElement("a");
      element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(text));
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    }

    const exportButtons = document.querySelectorAll(".h5vp_export_button");
    Object.values(exportButtons).map((item) => {
      const id = item.dataset.id;
      item.addEventListener("click", function (e) {
        e.preventDefault();
        $.ajax({
          url: h5vpAdmin?.ajaxUrl,
          data: {
            action: "h5vp_export_data",
            id,
          },
          method: "POST",
          success: (result) => {
            const url = window.URL.createObjectURL(new Blob([result], { type: "application/json" }));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `playlist-${id}.json`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            try {
              console.log({ result: JSON.parse(result) });
            } catch (error) {
              console.log({ result });
            }
          },
        });
      });
    });

    //import better

    const formWrapper = document.querySelector(".h5vp_import_form");
    const form = formWrapper?.querySelector("form");
    const closeBtn = formWrapper?.querySelector(".close");
    const notice = formWrapper?.querySelector(".h5vp-import-notice");
    closeBtn?.addEventListener("click", function () {
      formWrapper.style.display = "none";
    });

    form?.addEventListener("submit", function (e) {
      e.preventDefault();
      const fileInput = form.querySelector(".h5vp_import_file");
      if (fileInput.files[0]) {
        var reader = new FileReader();
        reader.readAsText(fileInput.files[0], "UTF-8");
        reader.onload = function (e) {
          const content = e.target.result;
          $.ajax({
            url: h5vpAdmin?.ajaxUrl,
            data: {
              action: "h5vp_import_data",
              id,
              content,
            },
            method: "POST",
            success: (result) => {
              console.log({ result });
              notice.style.display = "block";
              fileInput.value = "";
              setTimeout(() => {
                if (window.importReload) {
                  window.location.reload();
                }
                formWrapper.style.display = "none";
              }, 1000);
            },
          });
        };
        reader.onerror = function () {
          console.log("error importing");
        };
      }
    });

    const importButtons = document.querySelectorAll(".h5vp_import_button");
    Object.values(importButtons).map((item) => {
      item.addEventListener("click", function (e) {
        e.preventDefault();
        window.id = item.dataset.id;
        window.importReload = item.dataset.reload;
        notice.style.display = "none";
        formWrapper.style.display = "block";
      });
    });
  });
})(jQuery);

export function setCookie(cookieName, cookieValue, expiryInSeconds) {
  var expiry = new Date();
  expiry.setTime(expiry.getTime() + 1000 * expiryInSeconds);
  document.cookie = cookieName + "=" + escape(cookieValue) + ";expires=" + expiry.toGMTString() + ";path=/";
}

document.addEventListener("DOMContentLoaded", function () {
  const wrap = document.querySelector(".wrap");
  if (window.h5vpAdmin?.isPipe || !wrap) {
    return;
  }
  const menu = document.querySelector("#wp-admin-bar-apb_offer_menu");

  const offerElement = document.createElement("div");
  const html = `<div class='bpl-admin-notice-wrap'>
		<div class='bpl-admin-notice bpl-promotion'>
			<div class='notice-content'>
				<div class='logo-wrap'>
					<div class='bpl-logo'>
						<img src='https://ps.w.org/html5-video-player/assets/icon-128x128.png' />
					</div>
					<span class='bpl-icon bpl-icon-promotion'></span>
				</div>

				<div class='bpl-message'>
					<h3>Black Friday to Cyber Monday Exclusive.</h3>
					<div>Upgrade your WordPress experience with <strong>HTML5 Video Player Pro</strong> and save up to 40% during our biggest sale of the year!</div>
					<a href='edit.php?post_type=videoplayer&billing_cycle=annual&page=video-player-pricing-manual' class='bpl-btn bpl-btn-primary'>Save Big →</a>
				</div>

				<button class='bplPromoClose close-notice'>
					<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'>
						<path d='M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z' />
					</svg>
				</button>
			</div>
		</div>
	</div>`;

  offerElement.appendChild(htmlToElement(html));

  wrap.insertAdjacentElement("afterbegin", offerElement);

  const closeEl = offerElement.querySelector(".bplPromoClose");

  const isClosed = localStorage.getItem("h5vp_notice_closed");

  if (isClosed) {
    offerElement.classList.add("hidden");
  }

  closeEl?.addEventListener("click", (e) => {
    e.preventDefault();
    offerElement.classList.toggle("hidden");

    localStorage.setItem("h5vp_notice_closed", true);
  });

  menu?.addEventListener("click", function (e) {
    e.preventDefault();
    offerElement.classList.toggle("hidden");
  });
});

document.addEventListener("DOMContentLoaded", () => {
  let upgradePageEl = document.getElementById("fs_pricing");
  if (!upgradePageEl || window.h5vpAdmin?.isPipe) {
    upgradePageEl = document.getElementById("apbUpgradePage");
  }
  if (!upgradePageEl || window.h5vpAdmin?.isPipe) {
    return;
  }
  const pricingNotice = document.querySelector(".bpl-admin-notice-wrap");
  if (pricingNotice) {
    pricingNotice.classList.add("hidden");
  }
  const span = document.createElement("span");
  upgradePageEl.insertBefore(span, document.getElementById("fs_frame") || document.getElementById("fsUpgradePrice"));

  createRoot(span).render(<UpgradePageContent />);
});

const UpgradePageContent = () => {
  const countdownRef = useRef(null);

  useEffect(() => {
    downCount(countdownRef?.current, {
      date: `11/27/2023 23:59:00`,
      // offset: +6
    });
  }, []);

  return (
    <>
      <section className="intro">
        <div className="container">
          <div className="introHeader flex">
            <span>Experience the thrill of Black Friday with an epic 40% off!</span> <span style={{ color: "#ff5757" }}>Ending On</span>
            {/* <img width='60px' src='https://tastewp.com/intro/emoji.svg' /> */}
          </div>

          <div className="countdownWrap">
            <div className="countdown" ref={countdownRef}>
              <div>
                <span className="days">00</span>
                <span className="days_ref">days</span>
              </div>
              <span>
                :<br />
                &nbsp;
              </span>
              <div>
                <span className="hours">00</span>
                <span className="hours_ref">hours</span>
              </div>
              <span>
                :<br />
                &nbsp;
              </span>
              <div>
                <span className="minutes">00</span>
                <span className="minutes_ref">minutes</span>
              </div>
              <span>
                :<br />
                &nbsp;
              </span>
              <div>
                <span className="seconds">00</span>
                <span className="seconds_ref">seconds</span>
              </div>
            </div>
          </div>

          <div className="promoCode">Coupon: [FSBFCM2023]</div>
        </div>
      </section>
    </>
  );
};

const downCount = (container, options, callback) => {
  const settings = Object.assign({ date: null, offset: null }, options);

  const getText = (sl) => container.querySelector(sl).textContent;
  const setText = (sl, val) => {
    container.querySelector(sl).textContent = val;
  };

  if (!settings.date) {
    throw new Error("Date is not defined.");
  }

  if (!Date.parse(settings.date)) {
    throw new Error("Incorrect date format, it should look like this, 12/24/2012 12:00:00.");
  }

  const currentDate = () => {
    // get the client's current date
    const date = new Date();

    // turn the date to UTC
    const utc = date.getTime() + date.getTimezoneOffset() * 60000;

    return new Date(utc + 3600000 * settings.offset); // return a new Date object
  };

  function countdown() {
    // difference of dates
    const difference = new Date(settings.date) - currentDate();

    // if the difference is negative, then it's past the target date
    if (difference < 0) {
      // stop the timer
      clearInterval(interval);

      if (callback && typeof callback === "function") {
        callback();
      }

      return;
    }

    // basic math variables
    const _second = 1000;
    const _minute = _second * 60;
    const _hour = _minute * 60;
    const _day = _hour * 24;

    // calculate dates
    var days = Math.floor(difference / _day);
    var hours = Math.floor((difference % _day) / _hour);
    var minutes = Math.floor((difference % _hour) / _minute);
    var seconds = Math.floor((difference % _minute) / _second);

    // fix dates so that they will show two digits
    days = String(days).length >= 2 ? days : "0" + days;
    hours = String(hours).length >= 2 ? hours : "0" + hours;
    minutes = String(minutes).length >= 2 ? minutes : "0" + minutes;
    seconds = String(seconds).length >= 2 ? seconds : "0" + seconds;

    // based on the date change the reference wording
    var refDays = days === "01" ? "day" : "days";
    var refHours = hours === "01" ? "hour" : "hours";
    var refMinutes = minutes === "01" ? "minute" : "minutes";
    var refSeconds = seconds === "01" ? "second" : "seconds";

    // set the values to the DOM
    setText(".days", days);
    setText(".hours", hours);
    setText(".minutes", minutes);
    setText(".seconds", seconds);

    getText(".days_ref") === "days" && setText(".days_ref", refDays);
    getText(".hours_ref") === "hours" && setText(".hours_ref", refHours);
    getText(".minutes_ref") === "minutes" && setText(".minutes_ref", refMinutes);
    getText(".seconds_ref") === "seconds" && setText(".seconds_ref", refSeconds);
  }

  // start
  var interval = setInterval(countdown, 1000);

  // Return the interval for later use or stopping the countdown if needed
  return interval;
};
